/**
 * Navigation Drop Down Container.
 * For switching experience between personal, business and others as Version B
 *
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _set from 'lodash/set';
import Select from 'kepler/lib/components/Select';

// Lib Helper
import Page from '../../lib/page';
import { trackLink } from '../../lib/analytics-helper';

// Action
import { switchContentToggle } from '../../contactUs/actions/action-content-toggle';

// LabelData
import { labels } from '../constants/contentToggleData';

// Data Set
const selectedExp = Page.getUserExperience();
const currentPath = Page.getPathName();

// User Checker
const isLoggedIn = Page.isLoggedIn();
const isBusinessUser = Page.getIsBusinessUser();

let inputData = [];

class NavDropDown extends Component {
  // Select Box data parser
  static parseSelectBoxOptions(inputs) {
    if (inputs && inputs.length > 0) {
      return inputs.map(input => (
        {
          value: input.key,
          label: input.label,
        }
      ));
    }
    return [];
  }

  constructor(props) {
    super(props);
    this.state = {
      selectedExp,
    };

    this.changeHandlerSelectBox = this.changeHandlerSelectBox.bind(this);
  }

  // Update the Href link for toggle selection
  assignHref(toggleData) {
    toggleData.forEach((input) => {
      _set(input, 'href', this.pathNameWithExp(input.key));
    });
  }

  // Update the Label based on desktop and mobile
  assignLabel(toggleData) {
    const labelSet = this.props.labels.alternative;
    toggleData.forEach((input) => {
      _set(input, 'label', labelSet[input.key]);
    });
  }
  // Handle Select Box onChange event
  changeHandlerSelectBox(selectExp) {
    this.setState({
      selectedExp: selectExp,
    });
    const redirectUrl = this.pathNameWithExp(selectExp);
    this.trackFPTILink(selectExp);
    // Handle the tab not in the home page switch logic
    if (Page.checkPageInPath(this.props.pathname)) {
      Page.goTo(`${redirectUrl}`);
    }
  }

  // Filter the content in the toggle
  userTypeFilter() {
    if (!isLoggedIn) {
      return this.props.userExpClass;
    }
    return isBusinessUser ? this.props.userExpClass.filter(exp => exp !== 'personal') : this.props.userExpClass.filter(exp => exp !== 'business');
  }

  // Track FPTI with URL
  trackFPTILink(selectExp) {
    // TODO: Update the id/Page info for tracking
    trackLink({ id: this.props.FPTIPageName, link: `${this.props.FPTILink}|${selectExp}` });
  }

  // Create input content toggle data
  createLabelArray() {
    return this.userTypeFilter().map((exp, index) => (
      {
        key: exp,
        priority: index,
      }
    ));
  }
  // get Path with User experience
  pathNameWithExp(key) {
    let changedExp = '';
    const pathName = `${currentPath}${this.props.search}`;
    this.props.userExpClass.forEach((exp) => {
      const index = pathName.indexOf(exp);
      if (index >= 0 && exp !== key) {
        changedExp = exp;
      }
    });
    return changedExp ? pathName.replace(changedExp, key) : pathName;
  }

  // Render Select Box as the content toggle
  renderSelectBoxComponent(input) {
    const options = NavDropDown.parseSelectBoxOptions(input);
    // Update the global state: contentToggle -> exp
    this.props.switchContentToggle(this.state.selectedExp);
    return (
      <div className="dropdown-container">
        <div className="toggle-heading">{labels.alternative.title}</div>
        <Select
          value={this.state.selectedExp}
          onChange={this.changeHandlerSelectBox}
          options={options}
          placeholder={this.state.selectedExp}
          className="select-toggle"
        />
      </div>
    );
  }

  render() {
    inputData = this.createLabelArray();
    this.assignLabel(inputData);
    this.assignHref(inputData);
    return (
      <div className="nav-dropdown-container">
        {this.renderSelectBoxComponent(inputData)}
      </div>
    );
  }
}

// NavDropDown Props Types
NavDropDown.propTypes = {
  search: PropTypes.string,
  pathname: PropTypes.string,
  switchContentToggle: PropTypes.func.isRequired,
  userExpClass: PropTypes.arrayOf(PropTypes.string),
  labels: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  FPTIPageName: PropTypes.string,
  FPTILink: PropTypes.string,
};

// NavDropDown Props default values
NavDropDown.defaultProps = {
  search: '',
  pathname: '',
  userExpClass: ['personal', 'business', 'technical'],
  labels,
  FPTIPageName: 'homePage',
  FPTILink: 'smarthelp-content-toggle-url|dropdown-toggle',
};

// Get the Store data and Pass it as Props.
function mapStateToProps(state) {
  return {
    search: state.location.search,
    pathname: state.location.pathname,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ switchContentToggle }, dispatch);
}

// export default NavDropDown;
export default connect(mapStateToProps, mapDispatchToProps)(NavDropDown);
